import React from 'react'

import {
  BooleanField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  email: { id: 'email', label: 'E-Mail', renderer: LinkedField(ValueField) },
  firstName: { id: 'firstName', label: 'First Name', renderer: ValueField },
  lastName: { id: 'lastName', label: 'Last Name', renderer: ValueField },
  isActive: { id: 'isActive', label: 'Active', renderer: BooleanField },
}

export const ClientUserListTable = (props: ListTableProps) => {
  const { paginator, fields, extraActions } = props

  return (
    <>
      <PaginatedTable
        title="Client Users"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
      />
    </>
  )
}
